/**
 * Two-column paragraph split (acf.split_paragraph_text).
 * paragraph_one → left column, paragraph_two → right column.
 */

import { OpsiHtmlContent } from "../utils/OpsiHtmlContent";
import { hasHtmlContent, OPSI_PART_SPACING } from "../utils/opsiHelpers";

const columnProse =
  "text-[1rem] font-medium leading-[1.6] text-[#3b3d43] [&_p]:m-0 [&_p+p]:mb-5 [&_p+p]:mt-0 [&_strong]:font-bold [&_a]:text-[#1757A3] [&_a]:underline";

export const OpsiSplitParagraph = ({
  data,
  className = "opsi-split-paragraph",
}) => {
  const paragraphOne = data?.paragraph_one ?? "";
  const paragraphTwo = data?.paragraph_two ?? "";

  const hasLeft = hasHtmlContent(paragraphOne);
  const hasRight = hasHtmlContent(paragraphTwo);

  if (!hasLeft && !hasRight) {
    return null;
  }

  const singleColumn = hasLeft !== hasRight;
  const spanClass = singleColumn ? "md:col-span-2" : "";

  return (
    <section
      className={`${className} ${OPSI_PART_SPACING} w-full rounded-[20px]  `}
      data-opsi-part="split-paragraph"
    >
      <div
        className={`grid grid-cols-1 gap-8 md:gap-10 lg:gap-14 ${
          singleColumn ? "" : "md:grid-cols-2"
        }`}
      >
        {hasLeft ? (
          <OpsiHtmlContent
            html={paragraphOne}
            className={`opsi-split-paragraph__one ${columnProse} ${spanClass}`}
          />
        ) : null}

        {hasRight ? (
          <OpsiHtmlContent
            html={paragraphTwo}
            className={`opsi-split-paragraph__two ${columnProse} ${spanClass}`}
          />
        ) : null}
      </div>
    </section>
  );
};
